import f from "./index24.js";
import { resolveComponent as a, openBlock as r, createBlock as h, withCtx as e, createElementVNode as t, createElementBlock as g, withDirectives as l, createVNode as s, createTextVNode as d, toDisplayString as p, vShow as c, createCommentVNode as v, pushScopeId as y, popScopeId as w } from "vue";
import "./index25.js";
import "./index26.js";
import _ from "../../../../_virtual/index.js";
const D = (o) => (y("data-v-98b11169"), o = o(), w(), o), S = ["innerHTML"], k = {
  key: 0,
  class: "buttons-container"
}, B = ["action"], C = /* @__PURE__ */ D(() => /* @__PURE__ */ t("input", {
  type: "hidden",
  name: "format",
  value: "pdf"
}, null, -1));
function P(o, n, T, I, b, N) {
  const i = a("sequiter-button"), u = a("Dialog");
  return r(), h(u, {
    isOpen: o.showPolicyDialog,
    "onUpdate:isOpen": n[0] || (n[0] = (m) => o.showPolicyDialog = m),
    title: o.dialogTitle,
    variant: o.VARIANTS.ACTION_FIXED
  }, {
    default: e(() => [
      t("div", {
        id: "dialog-content",
        innerHTML: o.dialogContent
      }, null, 8, S),
      (o.showPrintButton || o.showSaveButton) && o.areTranslationsLoaded ? (r(), g("div", k, [
        l(s(i, { onClick: o.printDocument }, {
          default: e(() => [
            d(p(o.t(`${o.footerKeyPrefix}footer-policy-dialog.print-document`)), 1)
          ]),
          _: 1
        }, 8, ["onClick"]), [
          [c, o.showPrintButton]
        ]),
        l(t("form", {
          target: "_blank",
          method: "POST",
          action: o.dialogContentLink
        }, [
          C,
          s(i, { type: o.dialogBtntype }, {
            default: e(() => [
              d(p(o.t(`${o.footerKeyPrefix}footer-policy-dialog.save-document`)), 1)
            ]),
            _: 1
          }, 8, ["type"])
        ], 8, B), [
          [c, o.showSaveButton]
        ])
      ])) : v("", !0)
    ]),
    _: 1
  }, 8, ["isOpen", "title", "variant"]);
}
const E = /* @__PURE__ */ _(f, [["render", P], ["__scopeId", "data-v-98b11169"]]);
export {
  E as default
};
//# sourceMappingURL=index12.js.map
